angular.module('iqxCore')
	.controller('AgencyHomeCtrl', function ($scope, ApplicationSvc, ApiSvc, $location) {
		$scope.checkPermissions('AGENCY')

		$scope.GetTimesheetCount = function () {
			return ApiSvc.fetch($scope, { fetchAPI: 'callresult/NetCandidateProvTimesheetCount', fetchTarget: 'timesheetCount', fetchWithPersonID: true, multiRow: false })
		}

		$scope.GetOpportunitiesCount = function () {
			return ApiSvc.fetch($scope, { fetchAPI: 'callresult/NetAgencyCurrentRequirementCount', fetchTarget: 'opportunitiesCount', multiRow: false })
		}

		$scope.getAboutToExpireDocs = function () {
			return ApiSvc.fetch($scope, { fetchAPI: 'callresult/NetCandidateDocumentsAboutToExpire', fetchTarget: 'DocsAboutToExpire', multiRow: true })
		}

		$scope.navigateToPage = function (n) {
			$location.url(n)
		}

		if (ApplicationSvc.currentUser.UserClass == 'AGENCY') {
			$scope.GetTimesheetCount()
			$scope.GetOpportunitiesCount()
			$scope.getAboutToExpireDocs()
		}
	})
